export default function filter(type) {
  const types = [
    {_id: 1, name: 'Доходы'},
    {_id: 2, name: 'Расходы'},
    {_id: 3, name: 'Дивиденды'},
    {_id: 4, name: 'Инвестиции'},
  ];
  return types.find(el => el._id === type).name;
}
